import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhChartComponent } from '@shared/components/ph-chart/ph-chart.component';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [PhChartComponent],
  exports: [PhChartComponent],
  imports: [CommonModule, ChartsModule],
})
export class PhChartModule {}
